






























import Vue from 'vue';
import TableWidget from '@/components/dashboard/TableWidget.vue';
import { ColumnType, ESortTypes } from '@/components/table/types';
import { mapGetters } from 'vuex';
import i18n from '@/i18n';

export default Vue.extend({
  name: 'DashboardTable',
  components: { TableWidget },

  mounted() {
    this.changeColumn('dataSspTable', this.dataSspTable.options[0].value);
    this.changeColumn(
      'dataSiteDomainsTable',
      this.dataSiteDomainsTable.options[0].value
    );
    this.loadSspTable('-' + this.dataSspTable.options[0].value);
    this.loadSiteDomainsTable('-' + this.dataSiteDomainsTable.options[0].value);
  },

  computed: {
    ...mapGetters({
      getSspTable: 'dashboard/getSspTable',
      getSiteDomainsTable: 'dashboard/getSiteDomainsTable',
    }),
    sspLoader(): boolean {
      return this.$store.getters['dashboard/getLoader']('sspTable');
    },
    siteDomainsLoader(): boolean {
      return this.$store.getters['dashboard/getLoader']('siteDomainsTable');
    },
    refs(): any {
      return this.$refs;
    },
    defaultSort(): string {
      return ESortTypes.DESC;
    },
  },

  methods: {
    loadSspTable(sortData) {
      this.$store.dispatch('dashboard/loadSspTable', {
        fields: this.getFields('dataSspTable'),
        sort: sortData,
      });
    },
    loadSiteDomainsTable(sort) {
      this.$store.dispatch('dashboard/loadSiteDomainsTable', {
        fields: this.getFields('dataSiteDomainsTable'),
        sort,
      });
    },
    // TODO: Поправить запросы при смене селекта с состоянием сортировки
    changeSsp(field) {
      this.changeColumn('dataSspTable', field);
      this.loadSspTable(this.createSortData(field));
    },
    changeSiteDomainsSelect(field) {
      this.changeColumn('dataSiteDomainsTable', field);
      this.loadSiteDomainsTable(this.createSortData(field));
    },
    getFields(tableName) {
      return this[tableName].columns.map((column) => column.field).join(',');
    },
    createSortData(field) {
      switch (this.defaultSort) {
        case ESortTypes.ASC:
          return field;
        case ESortTypes.DESC:
          return '-' + field;
        case ESortTypes.NONE:
          return null;
      }
    },
    changeColumn(tableName, field) {
      const currentOption = this[tableName].options.find(
        (ssp) => ssp.value === field
      );

      if (currentOption) {
        const newColumn = {
          name: currentOption.label as string,
          field,
          useSort: true,
          align: 'right',
          type: ColumnType.TYPE_TEXT,
          options: {
            whiteSpace: 'nowrap',
          },
        };

        this.$set(this[tableName].defaultSort, 'field', field);
        this.$set(this[tableName].columns, 1, newColumn);
      }
    },
    changeSspSort(sortData) {
      this.loadSspTable(sortData);
    },
    changeSiteDomainsSort(sortData) {
      this.loadSiteDomainsTable(sortData);
    },
  },

  data() {
    return {
      dataSspTable: {
        defaultSort: {
          field: 'sum_revenue',
          sort: ESortTypes.DESC,
        },
        options: [
          {
            label: i18n.t('pages.dashboard.spend'),
            value: 'sum_revenue',
          },
          {
            label: i18n.t('pages.dashboard.impressions'),
            value: 'nurl',
          },
          {
            label: i18n.t('pages.dashboard.clicks'),
            value: 'clicks',
          },
          {
            label: i18n.t('pages.dashboard.cpc'),
            value: 'cpc',
          },
          {
            label: i18n.t('pages.dashboard.ctr'),
            value: 'ctr',
          },
        ],
        columns: [
          {
            name: i18n.t('pages.dashboard.name'),
            field: 'name',
            useSort: true,
            type: ColumnType.TYPE_TEXT,
          },
        ],
      },
      dataSiteDomainsTable: {
        defaultSort: {
          field: 'sum_revenue',
          sort: ESortTypes.DESC,
        },
        options: [
          {
            label: i18n.t('pages.dashboard.spend'),
            value: 'sum_revenue',
          },
          {
            label: i18n.t('pages.dashboard.impressions'),
            value: 'count_view',
          },
          {
            label: i18n.t('pages.dashboard.clicks'),
            value: 'count_click',
          },
          {
            label: i18n.t('pages.dashboard.cpc'),
            value: 'cpc',
          },
          {
            label: i18n.t('pages.dashboard.ctr'),
            value: 'ctr',
          },
        ],
        columns: [
          {
            name: i18n.t('pages.dashboard.name'),
            field: 'domain',
            useSort: true,
            type: ColumnType.TYPE_TEXT,
          },
        ],
      },
    };
  },
});
